import { namespacer } from 'helpers'

const namespace = namespacer('API')

export const LOAD_REQUEST = namespace('LOAD_REQUEST')
export const LOAD_SUCCESS = namespace('LOAD_SUCCESS')
export const LOAD_ERROR = namespace('LOAD_ERROR')
